import React, { useEffect } from "react";

import {
    CALCULATOR_KEYS,
    trackCalculatorStepSubmitted,
} from "@services/tracking";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import ResultField from "@components/Calculator/ResultField/resultField.component";
import ResultTitle from "@components/Calculator/ResultTitle/resultTitle.component";
import { Alert } from "@components/General/Alert/alert.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

import { CorrugatedSheetShoppingList } from "../corrugatedSheetCalculator.types";

type ResultComponentProps = {
    result: CorrugatedSheetShoppingList;
    mailParams: Record<string, string>;
};

const ResultComponent = ({ result, mailParams }: ResultComponentProps) => {
    const { t } = useGranite();
    const { surface, slope, hasSlopeWarning, productLine } = result;

    useEffect(() => {
        trackCalculatorStepSubmitted(CALCULATOR_KEYS.corrugateSheet);
    }, []);

    return (
        <div id="result">
            <ResultTitle mailParams={mailParams} />
            {hasSlopeWarning && (
                <Alert color="warning" fade={false}>
                    {t(
                        "calculator.corrugatedSheetCalculator.roofSlope.warning",
                    )}
                </Alert>
            )}
            {productLine && (
                <Row>
                    <Col>
                        <h3>
                            {t(
                                `calculator.corrugatedSheetCalculator.productLineTitle.${productLine}`,
                            )}
                        </h3>
                    </Col>
                </Row>
            )}
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.corrugatedSheetCalculator.roofSurface")}
                    unit={"m"}
                    sup={2}
                    value={(surface / 10_000).toFixed(3)}
                />
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.corrugatedSheetCalculator.roofSlope")}
                    unit={"%"}
                    value={slope.toFixed(2)}
                />
            </Row>
        </div>
    );
};

export default ResultComponent;
